import {
	Card,
	InputAdornment,
	LinearProgress,
	Slider,
	TextField,
	Typography,
} from '@material-ui/core';
import React from 'react';
import DownArrow from '@material-ui/icons/ArrowDropDown';
import UpArrow from '@material-ui/icons/ArrowDropUp';
import styles from './OptionsBoardStyles';
import { useDispatch, useSelector } from 'react-redux';
import { setAppStateAction } from '../../actions/appStateAction';
import { confidenceChangeFunc } from '../../Shared';

const SelectedExprationCard = ({ targetPriceChange }) => {
	const dispatch = useDispatch();
	const { appReducer, optionChainReducer } = useSelector((state) => state);
	const {
		isMobile,
		quoteInfo,
		targetPrice,
		skew,
		confidence,
		imp_vol,
	} = appReducer;
	const { latestPrice } = quoteInfo;

	const { selectedExpration } = optionChainReducer;

	const setAppState = (payload) => dispatch(setAppStateAction(payload));

	const targetChange = targetPrice - latestPrice;
	const targetChangePercent = targetPrice / latestPrice - 1;
	const absTargChangePerc = Math.abs(targetChangePercent * 100);

	return selectedExpration ? (
		<Card style={{ ...styles.selectorsMobile, width: '60%' }}>
			<div style={styles.selectorsFlex}>
				<div style={styles.selectorText}>
					Target {!isMobile && `Price`}
					{targetPrice && targetPrice !== 0 ? (
						<span
							style={
								targetChange < 0 ? styles.negPriceChange : styles.posPriceChange
							}
						>
							{targetChange < 0 ? (
								<DownArrow style={styles.downArrow} />
							) : (
								<UpArrow style={styles.upArrow} />
							)}
							{absTargChangePerc >= 100
								? absTargChangePerc.toFixed(0)
								: absTargChangePerc >= 10
								? absTargChangePerc.toFixed(1)
								: absTargChangePerc.toFixed(2)}
							%
						</span>
					) : (
						<span style={styles.posPriceChange} />
					)}
				</div>
				<TextField
					name='targetPrice'
					autoFocus
					style={styles.inputItem}
					type='number'
					step={0.01}
					min={latestPrice * 0.75 || 0}
					max={latestPrice * 1.25 || 0}
					value={targetPrice}
					InputProps={{
						style: {
							textAlign: 'center',
							fontSize: isMobile ? 16 : 14,
						},
						startAdornment: <InputAdornment position='start'>$</InputAdornment>,
					}}
					onChange={(event) => targetPriceChange(event.target.value)}
				/>
			</div>
			<div style={styles.selectorsFlex}>
				<Typography
					variant='inherit'
					component='h3'
					style={styles.selectorText}
				>
					Confidence ({(confidence * 10).toFixed(0)}
					%)
				</Typography>
				<Slider
					style={styles.sliderItem}
					name='confidence'
					value={confidence.toFixed(1) * 1}
					step={0.1}
					min={0}
					max={10}
					onChange={(event, value) =>
						confidenceChangeFunc(value, appReducer, setAppState)
					}
				/>
			</div>
		</Card>
	) : (
		<Card style={{ ...styles.selectorsMobile, width: '60%' }}>
			<div style={styles.selectorsFlexCenter}>
				<div style={{ ...styles.selectorText, fontSize: '0.7rem' }}>
					3M Sentiment
				</div>
				<div style={styles.progressBarContainer}>
					<div
						style={{
							...styles.progressLabelTextLeft,
							fontSize: '0.7rem',
						}}
					>
						Bull
					</div>
					<LinearProgress
						value={skew * 1}
						variant='determinate'
						color={'secondary'}
						style={styles.progressBar}
					/>
					<div
						style={{
							...styles.progressLabelTextRight,
							fontSize: '0.7rem',
						}}
					>
						Bear
					</div>
				</div>
			</div>
			<div style={styles.selectorsFlexCenter}>
				<div style={{ ...styles.selectorText, fontSize: '0.7rem' }}>
					1M ATM IV
				</div>

				<div style={styles.progressBarIVContainer}>
					<div
						style={{
							...styles.progressLabelTextLeft,
							fontSize: '0.7rem',
						}}
					>
						High
					</div>
					<LinearProgress
						value={100 - imp_vol * 1}
						variant='determinate'
						color={'secondary'}
						style={styles.progressBar}
					/>
					<div
						style={{
							...styles.progressLabelTextRight,
							fontSize: '0.7rem',
						}}
					>
						Low
					</div>
				</div>
			</div>
		</Card>
	);
};

export default SelectedExprationCard;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/SelectedExprationCard.jsx